/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Settings_Template_Topic_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove topic {position}" |
*
* @param {Settings_Template_Topic_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_remove = /** @type {((inputs: Settings_Template_Topic_RemoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_RemoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Onderwerp ${i?.position} verwijderen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer le sujet ${i?.position}`)
	return /** @type {LocalizedString} */ (`Remove topic ${i?.position}`)
});